
import Vue from "vue";

import { userMapActions, userMapState } from "@/store/modules/user";
import { isAfter } from "date-fns";
import { restrictedUserFormSchema } from "@/forms/admin/restrictUser";
import { RestrictUserFields } from "@/store/modules/user/types";
import { ITableWrapperColumns, IUserRestricted } from "@/types";
import { tableColumnsListUsers } from "./TableColumns";

interface IListUsersData {
  restrictData: IUserRestricted;
  loading: boolean;
  fields: any;
  tableColumns: ITableWrapperColumns;
}

export default Vue.extend({
  name: "restrict-users",
  props: {
    selectedUsers: {
      type: Array,
      required: true
    }
  },
  data(): IListUsersData {
    return {
      loading: false,
      restrictData: {
        indefinite: false,
        startDate: new Date(),
        endDate: new Date()
      },
      fields: restrictedUserFormSchema(),
      tableColumns: tableColumnsListUsers
    };
  },
  methods: {
    ...userMapActions(["getUsers", "banUsers", "restrictUsers"]),
    restrictSelectedUsers() {
      this.$emit("restrictSelectedUsers", this.restrictData);
    },
    formFieldChangeHandler({
      key,
      value
    }: {
      key: RestrictUserFields;
      value: any;
    }): void {
      this.restrictData[key] = value;
    },
    hideModal() {
      this.$emit("hideModal");
    }
  },
  computed: {
    ...userMapState(["makingApiRequest"]),
    showSubmitButton() {
      if (isAfter(this.restrictData.endDate, this.restrictData.startDate)) {
        return true;
      } else {
        return false;
      }
    }
  }
});
